export default __webpack_public_path__ + "static/media/moon-man.db6446af.svg";